// extracted by mini-css-extract-plugin
module.exports = {"appSectionText":"AppSectionTitle_appSectionText__1I2tH","appSectionTitleBar":"AppSectionTitle_appSectionTitleBar__2qgam"};